module.exports = __webpack_public_path__ + "static/media/README.2c2ebe77.md";